<script>
	import { onMount, getContext } from 'svelte'
	import { fade } from 'svelte/transition'
	import { styles } from '../scripts/styles.js'

	let visible = false
	const globals = getContext('globals')
	export let bg = globals.bgShader
	export let showLogo = 'none'
	export let opacity = '1'
	export let marginTop = '0px'
	export let shaderWidth = '100vw'

	onMount(() => {
		visible = true
	})
</script>

{#if visible}
	<div out:fade={{ duration: 1000 }} class="shader" use:styles={{ bg, opacity, marginTop, shaderWidth }}>
		{#if showLogo === 'show'}
			<div class="logo" />
		{/if}
		<slot name="content" />
	</div>
{/if}

<style>
	.shader {
		position: fixed;
		top: var(--marginTop);
		left: 0px;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		width: var(--shaderWidth);
		background-color: var(--bg);
		z-index: 10000;
		opacity: var(--opacity);
	}

	.logo {
		position: fixed;
		top: 20px;
		width: 15%;
		height: 10%;
		background-image: url('../images/logo.svg');
		background-size: contain;
		background-repeat: no-repeat;
	}
</style>
